import home_page from "./pages/home.js";
import choice_page from "./pages/choice.js";
import live_page from "./pages/live.js";
import result_page from "./pages/result.js";
import print_page from "./pages/print.js";
import { v4 as uuidv4 } from 'uuid';
export default {
    home_page: {
        text: "Accueil",
        constructor: home_page,
        idSoft: uuidv4()
    },
    choice_page: {
        text: "Choix de composition",
        constructor: choice_page,
        idSoft: uuidv4()
    },
    live_page: {
        text: "Live / Prise de vue",
        constructor: live_page,
        idSoft: uuidv4()
    },
    print_page: {
        text: "Impression",
        constructor: print_page,
        idSoft: uuidv4()
    },
    // result_page: {
    //     constructor: result_page,
    //     idSoft: uuidv4()
    // }
}
